import { DepartmentDTO } from './DepartamentDTO';
import { HeatmapValueDTO } from './HeatmapValueDTO';
import { KeyDriversDTO } from './KeyDriversDTO';
import { Serializable } from './Serializable';

export class HeatmapDTO extends Serializable {
    departments: DepartmentDTO[];
    keyDrivers: KeyDriversDTO[];
    values: HeatmapValueDTO[];

    constructor() {
        super();
    }

}
